export const lazyLoadImages = () => {


	var lazyImgs = [].slice.call(document.querySelectorAll(".js__lazy-img"));

	if ("IntersectionObserver" in window) {
		var lazyImgObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(img) {
				if (img.isIntersecting) {
					
					let realSrc = img.target.dataset.src;

					img.target.src = realSrc;
					img.target.dataset.src = '';
					
					lazyImgObserver.unobserve(img.target);
				}
			});
		});

		lazyImgs.forEach(function(lazyImg) {
			lazyImgObserver.observe(lazyImg);
		});
	}

}